var magicStyles = [".form[data-v-2ecf0858]{display:flex;flex-direction:column;align-items:center}.title[data-v-2ecf0858]{font-size:1rem;display:block;margin:0 0 var(--magic-space,16px);min-height:50px;text-align:center}.action[data-v-2ecf0858]{margin:0 auto;width:100%;max-width:var(--magic-element-default-width,288px)}"];

export default magicStyles;
